import React from "react";
import { useStaticQuery, Link, graphql } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { FiPhone, FiMenu, FiX } from "react-icons/fi";
import tw from "twin.macro";

export default function Header() {
  const { site } = useStaticQuery(query);
  const { tel } = site.siteMetadata;

  const [mobileMenu, setMobileMenu] = React.useState(false);
  return (
    <header id="header" tw="border-t-4 border-primary shadow-lg">
      <nav tw="container mx-auto px-6 flex items-center justify-between">
        <Link to="/">
          <StaticImage
            src="../images/logo.svg"
            placeholder="blurred"
            alt="A & F Garten- und Landschaftsbau "
            width={200}
          />
        </Link>
        <div tw="hidden lg:flex">
          <Link
            tw="text-lg ml-1 hover:bg-gray-100 rounded-md py-2 px-4 hover:text-primary"
            to="/#service"
          >
            Unsere Leistungen
          </Link>
          <Link
            tw="text-lg ml-1 hover:bg-gray-100 rounded-md py-2 px-4 hover:text-primary"
            to="/#whyus"
          >
            Ihre Vorteile
          </Link>
          <Link
            tw="text-lg ml-1 hover:bg-gray-100 rounded-md py-2 px-4 hover:text-primary"
            to="/#contact"
          >
            Kontakt
          </Link>
          <a
            tw="text-lg hover:bg-gray-100 px-4 rounded-md inline-flex items-center ml-1 font-medium text-primary"
            href={"tel:" + tel}
          >
            <FiPhone size={24} tw="mr-2" /> {tel}
          </a>
        </div>
        <button
          onClick={() => setMobileMenu(true)}
          tw="p-2 focus:outline-none rounded-md hover:bg-gray-100 lg:hidden"
        >
          <FiMenu size={24} />
        </button>
        <div
          css={[
            tw`absolute top-0 left-0 w-full p-6 lg:hidden`,
            !mobileMenu && tw`hidden`,
          ]}
        >
          <div tw="bg-white relative p-6 border-t-4 shadow-2xl rounded-b-lg border-primary">
            <button
              onClick={() => setMobileMenu(false)}
              tw="p-2 absolute right-0 top-0 m-4 focus:outline-none rounded-md hover:bg-gray-100"
            >
              <FiX size={24} />
            </button>
            <Link
              tw="text-lg mt-6 hover:bg-gray-100 rounded-md p-2 text-center block hover:text-primary"
              to="/#service"
            >
              Unsere Leistungen
            </Link>
            <Link
              tw="text-lg mt-2 hover:bg-gray-100 rounded-md p-2 text-center block hover:text-primary"
              to="/#whyus"
            >
              Ihre Vorteile
            </Link>
            <Link
              tw="text-lg mt-2 hover:bg-gray-100 rounded-md p-2 text-center block hover:text-primary"
              to="/#contact"
            >
              Kontakt
            </Link>
            <a
              tw="text-lg mt-2 hover:bg-gray-100 rounded-md p-2 text-center flex justify-center items-center font-medium text-primary"
              href={"tel:" + tel}
            >
              <FiPhone size={24} tw="mr-2" /> {tel}
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

const query = graphql`
  query {
    site {
      siteMetadata {
        tel
      }
    }
  }
`;
